import { render, staticRenderFns } from "./ProfileSuggestedPages.vue?vue&type=template&id=1d4d6ea2&"
import script from "./ProfileSuggestedPages.vue?vue&type=script&lang=js&"
export * from "./ProfileSuggestedPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d4d6ea2')) {
      api.createRecord('1d4d6ea2', component.options)
    } else {
      api.reload('1d4d6ea2', component.options)
    }
    module.hot.accept("./ProfileSuggestedPages.vue?vue&type=template&id=1d4d6ea2&", function () {
      api.rerender('1d4d6ea2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/profile/ProfileSuggestedPages.vue"
export default component.exports